import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChecklistGroup, ChecklistItem } from '../../../interfaces/checklist.model';
import { CommonModule } from '@angular/common';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ButtonModule } from 'primeng/button';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ModalComponent } from '../../../shared/components/modal/modal.component';
import { EditpdfComponent } from '../../editpdf/editpdf.component';
import { CommPreferenceComponent } from '../comm-preference/comm-preference.component';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { RADIO_YES_NO_OPTIONS } from '../../../shared/constants/static-data.constants';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormChecklistComponent } from '../form-checklist/form-checklist.component';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'ppl-checklist-view',
  standalone: true,
  imports: [NzCollapseModule,
    CommPreferenceComponent,
    CommonModule, ButtonModule,
    NzToolTipModule,
    NzRadioModule,
    NzButtonModule,
    ButtonComponent,
    ModalComponent,
    EditpdfComponent,
    NzAlertModule,
    NzInputModule,
    NzDatePickerModule,
    FormChecklistComponent,
    DropdownSelectComponent,
    NzSelectModule,
    FormsModule],
  templateUrl: './checklist-view.component.html',
  styleUrl: './checklist-view.component.css'
})
export class ChecklistViewComponent implements OnInit {
  @Input() checklistData: ChecklistGroup[] = [];
  @Input() showNoRecordsMesssage = true;
  @Input() isSelf = true;
  @Output() viewPDF = new EventEmitter<ChecklistItem>();
  @Output() disableSave = new EventEmitter<any>();
  @Output() showError = new EventEmitter<any>();
  @Input() HREdit = false;
  @Input() showSaveError = false;
  message: any;
  showPlaceholderForIds: any = [91, 68, 65, 51, 76, 63, 64]

  radioOptions = RADIO_YES_NO_OPTIONS;
  date = '';
  today = new Date().toLocaleDateString('en-CA');
  dateError = false;
  expirationDateError = false;

  ngOnInit(): void {
    if (this.isSelf) {
      this.message = "No Self checklist available for you.";
    } else {
      this.message = "Checklist is not applicable to your association with the consumer.";
    }
  }

  isPanelActive(group: ChecklistGroup): boolean {
    return group.isActive;
  }

  onPanelActiveChange(isActive: boolean, group: ChecklistGroup): void {
    group.isActive = isActive;
  }

  getAriaLabel(checklistItem: any): string {
    const label = (checklistItem.question.toLowerCase()?.includes('signed') ? checklistItem.question.replace(/\b(signed and dated)?\b/gi, '').trim() : checklistItem.question);
    return `${label} view form`.trim();
  }

  onPanelHeaderKeyPress(group: ChecklistGroup) {
    group.isActive = !group.isActive;
  
    if (group.isActive) {
      setTimeout(() => {
        const panelEl = document.querySelector(
          `[data-checklist-id="${group.checklistName}"]`
        );
        const focusTarget = panelEl?.querySelector(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ) as HTMLElement;
        focusTarget?.focus();
      }, 100);
    }
  }

  validateDate(value: string, item: any) {
    if (item.question !== 'E-Verify Processed Date') return;
    if (!value) {
      this.dateError = false;
      return;
    }
    this.dateError = value > this.today;
    this.disableSave.emit(this.dateError);
  }

  onDropdownValueChange(checklistItem: any){
    if(checklistItem.checklistItemId === 91){
      this.showError.emit(false);
      checklistItem.toDate = null;
      this.expirationDateError = false;
      this.disableSave.emit(false);
    }
  }

  validateExpirationDate(value: string) {
    this.showError.emit(false);
    this.expirationDateError = false;
    if (!value) {
      this.expirationDateError = false;
      return;
    }

    const selectedDate = new Date(value);
    const todayDate = new Date(this.today);
    selectedDate.setHours(0, 0, 0, 0);
    todayDate.setHours(0, 0, 0, 0);
    this.expirationDateError = selectedDate < todayDate;
    this.disableSave.emit(this.expirationDateError);
  }

  onChange(event: any, item: ChecklistItem) {
    item.fromDate = event[0] ? event[0].toISOString().split('T')[0] : '';
    item.toDate = event[1] ? event[1].toISOString().split('T')[0] : '';
  }

  handleCheckListClick(form: ChecklistItem) {
    this.viewPDF.emit(form);
  }
}